/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Purchase {
    import fld = MaterialInBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MaterialInBOMEditor extends _Ext.BOMGridEditor<MaterialInBOMRow> { 
        protected getDialogType() { return MaterialInBOMDialog; }
        protected getLocalTextPrefix() { return MaterialInBOMRow.localTextPrefix; }
      
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as Purchase.MaterialInItemsDialog).CalculateTotals();
                }
            })

        }

        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }

        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }
         
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.RawMaterialMasterSelectGrid;

            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                onClick: () => {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var Purchasedetails = [];
                        var ratelistId = this.RateListId;
                        selectedItems2.forEach(function (value) {
                            var prdid = value.ProductId;


                            let PrdDetails;
                            OMS.ProductMasterService.Retrieve({
                                EntityId: parseInt(prdid)
                            }, response => {
                                PrdDetails = response.Entity
                            }, { async: false });
                            var Pieces = 0;
                            var Weight = 0.01;
                            var Rate = 0;
                            var Amount = 0;

                            if (PrdDetails.ItemTypeId == 104) {
                                var MetalRate = GetItemRateHelper.GetGetMetalRate(PrdDetails.ProductTypeId);
                                Rate = MetalRate;
                                Amount = Rate * Weight * PrdDetails.Purity;

                            }
                            else {
                                var ItemRate = GetItemRateHelper.GetSalesRate(PrdDetails.AttributeId, ratelistId);
                                Rate = ItemRate;
                                Pieces = 1;
                                if (PrdDetails.CalcOnId == 3) {
                                    Amount = Rate * Pieces
                                }
                                else {
                                    Amount = Rate * Weight;
                                }
                            }


                            var PurchaseBom: QuotationBOMRow = {
                                BOMProductId: prdid,

                                ProductCode: value.ProductCode,
                                BOMAttributeId: value.AttributeId,
                                Attribute: PrdDetails.Attribute,
                                ItemType: PrdDetails.ItemType,
                                ItemTypeId: PrdDetails.ItemTypeId,

                                StoneColorId: PrdDetails.StoneColorId,
                                MetalColorId: PrdDetails.MetalColorId,
                                KaratId: PrdDetails.KaratId,

                                BomRate: Rate,
                                Pieces: Pieces,
                                Weight: Weight,
                                CalcOn: value.CalcOnId,
                                ShapeId: PrdDetails.ShapeId,
                                QualityId: PrdDetails.QualityId,

                                Purity: PrdDetails.Purity,
                                BomAmount: Amount
                            };
                            Purchasedetails.push(PurchaseBom);

                        });


                        for (let PurchaseDetail of Purchasedetails) {
                            PurchaseDetail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(PurchaseDetail);
                        }
                    }

                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }


    }
}